import { ListSubheader, styled } from '@mui/material';
import { ReactNode } from 'react';

export type MenuLabelProps = {
  children: ReactNode;
};

const StyledListSubheader = styled(ListSubheader)(({ theme }) => ({
  background: 'transparent',
  color: 'var(--text-text-secondary-color)',
  fontSize: 12,
  lineHeight: 1.5,
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
}));

export const MenuLabel = ({ children }: MenuLabelProps) => {
  return <StyledListSubheader>{children}</StyledListSubheader>;
};
